import { html } from 'htm/preact'
import { useState, useEffect } from 'preact/hooks'

export default function Sheet({ open, onClose, title, children }) {
  const [mounted, setMounted] = useState(open)
  const [visible, setVisible] = useState(open)

  useEffect(() => {
    if (open) {
      setMounted(true)
      // double rAF ensures CSS transition fires after mount
      requestAnimationFrame(() => requestAnimationFrame(() => setVisible(true)))
    } else {
      setVisible(false)
      const t = setTimeout(() => setMounted(false), 300)
      return () => clearTimeout(t)
    }
  }, [open])

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : ''
    return () => { document.body.style.overflow = '' }
  }, [open])

  if (!mounted) return null

  return html`
    <div
      class="sheet-overlay"
      style=${{ opacity: visible ? 1 : 0, transition: 'opacity 0.25s', pointerEvents: visible ? 'auto' : 'none' }}
      onClick=${onClose}
    >
      <div
        class="sheet"
        style=${{ transform: visible ? 'translateY(0)' : 'translateY(100%)', transition: 'transform 0.3s cubic-bezier(0.32,0.72,0,1)' }}
        onClick=${e => e.stopPropagation()}
      >
        <div class="sheet__grip"></div>
        <h2 class="sheet__title">${title}</h2>
        <div class="sheet__body">${children}</div>
      </div>
    </div>
  `
}
